import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { t } from 'i18next';

import { Icomoon } from '../Icomoon';

class UserMenu extends Component {

	static propTypes = {
		user: PropTypes.object,
		className: PropTypes.string,
		kind: PropTypes.oneOf(['dropdown','navbar']),
		closeMenu: PropTypes.func
	};

	static defaultProps = {
		user: {},
		kind: 'dropdown',
		className: '',
		closeMenu: () => void 0
	};

	render() {

		const { kind, user, className, closeMenu, ...other } = this.props;

		const wrapperClasses = classNames(
			'tbk--user-menu',
			{
				'tbk--user-menu--dropdown' : kind === 'dropdown',
				'tbk--user-menu--navbar' : kind === 'navbar'
			},
			className
		);

		switch ( kind ) {
			case 'dropdown':
				return (
					<div className={wrapperClasses} key={kind} {...other}>
						<div className="tbk--user-menu__name">
							{user.display_name}
						</div>
						<Icomoon icon="chevron-down" size="xs" />
					</div>
				);
			case 'navbar':
				return [
					<li className="bx--overflow-menu-options__option" key={kind}>
						<Link className="bx--link bx--overflow-menu-options__btn" to="/edit-profile">{t('Edit Profile')}</Link>
					</li>
				];
			default: return (
				<ul className={wrapperClasses} {...other} key={kind}>
					<li>
						<Link className="tbk--user-menu__link" to="/edit-profile">
							<div className="tbk--user-menu__content">
								<div className="tbk--user-menu__name">
									{user.display_name}
								</div>
								<div className="tbk--user-menu__edit">
									{t('Edit Profile')}
								</div>
							</div>
						</Link>
					</li>
				</ul>
			);
		}
	}
}

export { UserMenu };



// WEBPACK FOOTER //
// ./src/components/UserMenu/UserMenu.js